module.exports = __webpack_public_path__ + "static/media/arrow-down-import.14adf861.svg";